import useManyRemoteM1 from '@aims/shared/shared/use-many-remote-m1';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import CSPage from '../../components/CSPage';
import CSPageHeader from '../../components/CSPageHeader';
import settings from '../../settings';
import { generateUuid } from '../../shared/utils';
import ListReportScheduleTemplates from './ListReportScheduleTemplates';
import {
  allReportScheduleTemplatesQuery,
  extractAllReportScheduleTemplates,
} from './constants';

function ListReportScheduleTemplatesPage() {
  const createId = useMemo(() => {
    return generateUuid();
  }, []);

  const [sortedBy, setSortedBy] = useState('updatedAt');
  const [sortOrder, setSortOrder] = useState('DESC');
  const filters = useRef({});
  const sortBy = useRef([
    { key: sortedBy, order: sortOrder },
    { key: '_score', order: 'DESC' },
  ]);

  const {
    error,
    loading,
    data: templates,
    search: templatesSearch,
    hasNextPage,
    next,
    refetch,
  } = useManyRemoteM1({
    query: allReportScheduleTemplatesQuery,
    extract: extractAllReportScheduleTemplates,
    first: settings.querySize,
    filters: filters.current,
    sortBy: sortBy.current,
    fetchPolicy: 'network-only',
    queryId: 'listReportScheduleTemplatesPage',
  });

  const onSortedByChange = useCallback(
    (value) => {
      sortBy.current = [{ key: value, order: sortOrder }];
      refetch();
      setSortedBy(value);
    },
    [sortOrder, refetch],
  );

  const onSortOrderChange = useCallback(
    (value) => {
      sortBy.current = [
        { key: sortedBy, order: value },
        { key: '_score', order: 'DESC' },
      ];
      refetch();
      setSortOrder(value);
    },
    [sortedBy, refetch],
  );

  const onFiltersChanged = useCallback(
    (_changed) => {
      const { search, ...changed } = _changed;
      if (search != undefined) {
        sortBy.current = [
          { key: '_score', order: 'DESC' },
          { key: sortedBy, order: sortOrder },
        ];
        templatesSearch(search);
      } else {
        filters.current = {
          ...filters.current,
          ...Object.entries(changed).reduce((prev, [k, v]) => {
            prev[k] = v ? v : undefined;
            return prev;
          }, {}),
        };
        refetch();
      }
    },
    [templatesSearch, refetch, sortedBy, sortOrder],
  );

  return (
    <>
      <CSPage
        containerStyle={{ maxWidth: 'unset' }}
        title="Scheduled Report Templates"
      >
        <CSPageHeader
          title="Scheduled Report Templates"
          topActions={[
            <Link
              key="add"
              to={{
                pathname: `/report-schedule-template/edit/${createId}`,
                state: { mode: 'create' },
              }}
            >
              <Button type="link" icon={<PlusCircleOutlined />} size="large">
                Add a Scheduled Report Template
              </Button>
            </Link>,
          ]}
        />
        <ListReportScheduleTemplates
          loading={loading}
          error={error}
          templates={templates}
          next={next}
          hasNextPage={hasNextPage}
          refetch={refetch}
          onFiltersChanged={onFiltersChanged}
          onSortedByChange={onSortedByChange}
          onSortOrderChange={onSortOrderChange}
        />
      </CSPage>
      <style jsx>{``}</style>
    </>
  );
}

export default ListReportScheduleTemplatesPage;
